import React from 'react';
import { defineMessages } from 'react-intl';

import { MarginDiv } from '../../containers/styled/layout';
import { useDatabase } from '../../context/database';
import { deleteFacilityCategory } from '../../controllers/facilities/FacilityCategoryController';
import { getCollection } from '../../rxdb/collections';
import { permissions } from '../../utils/auth';
import DataEntity from '../generic/DataEntity';
import FormComponent from './subcomponents/FacilityCategoryForm';
import ViewComponent from './subcomponents/FacilityCategoryView';

const messages = defineMessages({
  title: {
    id: 'facility.category.title',
    defaultMessage: 'Facility Categories'
  },
  count: {
    id: 'facility.category.count.label',
    defaultMessage: 'Category(s)'
  },
  searchPlaceHolder: {
    id: 'facility.category.search.placeholder',
    defaultMessage: 'Search categories'
  },
  name: {
    id: 'facility.category.name',
    defaultMessage: 'Category name'
  },
  details: {
    id: 'facility.category.details',
    defaultMessage: 'Details'
  },
  add: {
    id: 'facility.category.add.button',
    defaultMessage: 'Create category'
  }
});

const ADD = permissions.facilityCategory.add;
const EDIT = permissions.facilityCategory.edit;
const DELETE = permissions.facilityCategory.del;

/**
 * Facility Category screen
 *
 * List of available facility categories.
 *
 * @component
 * @example
 * return (
 *    <FacilityCategory />
 * );
 */
const FacilityCategory = () => {
  const db = useDatabase();

  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const subscription = getCollection(db, 'facilityCategory')
      .find()
      .where({ isActive: true })
      .sort({ name: 1 })
      .$
      .subscribe((entries) => {
        const docs = entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
          details: entry.details,
          lastmodifiedAt: entry.lastmodifiedAt,
          lastSynchedAt: entry.lastSynchedAt
        }));

        setData(docs);
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [db]);

  return (
    <MarginDiv data-testid='facility-category'>
      <DataEntity
        crumbs={['facilitiesGroup', 'facilityCategory']}
        data={data}
        columns={[
          { dataKey: 'name', label: messages.name },
          { dataKey: 'details', label: messages.details, flex: 2 }
        ]}
        addPerm={ADD}
        editPerm={EDIT}
        FormComponent={FormComponent}
        deletePerm={DELETE}
        onDelete={deleteFacilityCategory}
        ViewComponent={ViewComponent}
        messages={messages}
      />

    </MarginDiv>
  );
};

export default FacilityCategory;
